import { followUps } from "@/mocks/homeData";
import { SectionHead, Shell } from "./ui";

const statusStyle: Record<string, { cls: string; icon: string }> = {
  已澄清: { cls: "bg-secondary-100 text-secondary-900 border-secondary-200", icon: "ri-check-line" },
  新进展: { cls: "bg-primary-100 text-primary-800 border-primary-200", icon: "ri-refresh-line" },
  待回应: { cls: "bg-accent-100 text-accent-900 border-accent-200", icon: "ri-hourglass-line" },
};

export default function FollowUpSection() {
  return (
    <section className="bg-background-50">
      <Shell>
        <div className="py-10 md:py-14">
          <SectionHead
            id="follow"
            kicker="Follow-up · 事件后续追踪"
            title="争议事件后续追踪"
            subtitle="反转不只看一时，更要看落地。跟踪每个事件的澄清、新进展与仍未回应的悬置项，掌握最终走向。"
            linkText="订阅后续推送"
          />

          <div className="relative mx-auto max-w-3xl">
            {/* 竖线 */}
            <span className="absolute left-[9px] top-2 h-[calc(100%-16px)] w-px bg-background-300 md:left-[11px]" />
            <div className="flex flex-col gap-6">
              {followUps.map((f) => {
                const s = statusStyle[f.status];
                return (
                  <div key={f.date} className="relative flex gap-4 md:gap-6">
                    <span className="relative z-10 mt-1 grid h-5 w-5 shrink-0 place-items-center rounded-full border-2 border-background-300 bg-background-50 md:h-6 md:w-6">
                      <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
                    </span>
                    <div className="min-w-0 flex-1 rounded-xl border border-background-200 bg-background-100/40 p-4 md:p-5">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="inline-flex items-center gap-1 text-xs font-semibold text-foreground-600">
                          <i className="ri-calendar-line" />{f.date}
                        </span>
                        <span className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-semibold ${s.cls}`}>
                          <i className={s.icon} />{f.status}
                        </span>
                      </div>
                      <h3 className="mt-2 font-heading text-base font-bold text-foreground-950 md:text-lg">
                        <a href="#top">{f.title}</a>
                      </h3>
                      <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{f.text}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </Shell>
    </section>
  );
}